import { ThemeProvider } from "@emotion/react";
import theme from "./Theme";
import { SnackbarProvider } from "./provider/SnackbarProvider";
import App from "./App";
import { AuthProvider } from "./provider/AuthProvider";
import { GameProvider } from "./provider/GameProvider";
import { DialogProvider } from "./provider/DialogProvider";
import { PopupProvider } from "./provider/PopupProvider";

export function AppWithProvider() {
  return (
    <ThemeProvider theme={theme}>
      <PopupProvider>
        <SnackbarProvider>
          <GameProvider>
            <AuthProvider>
              <DialogProvider>
                <App />
              </DialogProvider>
            </AuthProvider>
          </GameProvider>
        </SnackbarProvider>
      </PopupProvider>
    </ThemeProvider>
  );
}
